import script from "./InstrumentoDetalle.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstrumentoDetalle.vue?vue&type=script&setup=true&lang=ts"

import "./InstrumentoDetalle.vue?vue&type=style&index=0&id=371dc8ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-371dc8ac"]])

export default __exports__